import { render, staticRenderFns } from "./CustTagEdit.vue?vue&type=template&id=35cb56d6&scoped=true"
import script from "./CustTagEdit.vue?vue&type=script&lang=js"
export * from "./CustTagEdit.vue?vue&type=script&lang=js"
import style0 from "./CustTagEdit.vue?vue&type=style&index=0&id=35cb56d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cb56d6",
  null
  
)

export default component.exports